import { useMemo } from 'react';
import DashboardCard from '@/components/reusables/dashboard/DashboardCard';
import SearchAndFilter from '@/components/reusables/dashboard/SearchAndFilter';
import { CircleDollarSign, ReceiptText, UserRound, UserRoundPlus } from 'lucide-react';
import {
  useFetchAdminData,
  useFetchFailedImportCount,
  useSubscriptionCounts,
} from '@/hooks/dashboardHooks';
import DashboardSkeleton from '@/components/reusables/DashboardSkeleton';
import { useNavigate } from 'react-router';
import SubscriptionsBarChart from './SubscriptionBarChart';
import MapSection from './MapSection';
import { statusFilter } from '@/store/alertFilterStore';

// const SubscriptionsBarChart = lazy(() => import('./SubscriptionBarChart'));
// const MapSection = lazy(() => import('./MapSection'));

const DashboardMainComp = () => {
  const { data: count, isLoading, isError, isFetching } = useFetchAdminData();
  const { isLoading: chartLoader } = useSubscriptionCounts();
  const { monthlyRevenue, monthlyOnboarded, totalSubscribers } = count || {};
  const navigate = useNavigate();
  // const { data: totalSubscriberCount } = useFetchTotalSubscribersCount();

  // const { data: totalOnboardedCount } = useFetchTotalOnboardedCount();
  // const { data: totalRevenue } = useFetchTotalRevenue();

  const { data: failedImportCount } = useFetchFailedImportCount();
  const setStatus = statusFilter((s) => s.setStatus);

  const dashboardCards = useMemo(
    () => [
      {
        title: 'Total Subscribers',
        value: totalSubscribers ?? 0,
        icon: UserRound,
        leadingIcon: '',
      },
      {
        title: 'Monthly Onboarded',
        value: monthlyOnboarded ?? 0,
        icon: UserRoundPlus,
        leadingIcon: '',
      },
      {
        title: 'Monthly Revenue',
        value: monthlyRevenue ?? 0.0,
        icon: CircleDollarSign,
        leadingIcon: '$',
      },
      // {
      //   title: 'Failed Imports',
      //   value: failedImportCount ?? 0,
      //   icon: ReceiptText,
      //   leadingIcon: '',
      // },
    ],
    [totalSubscribers, monthlyOnboarded, monthlyRevenue, failedImportCount]
  );

  const handleImportClick = () => {
    navigate('/superadmin/alerts');
    setStatus(false);
  };

  if (isLoading || chartLoader || isFetching) {
    return (
      <div className="itemcenter flex justify-center">
        <DashboardSkeleton />
      </div>
    );
  }

  if (isError) {
    return <div className="itemcenter text-center text-red-500">Failed to load dashboard data</div>;
  }

  return (
    <div className="dashboard-content-wrap">
      <div className="mb-6 grid grid-cols-4 gap-5">
        {dashboardCards?.map((card, idx) => (
          <div className="d-card-item" key={idx}>
            <DashboardCard
              title={card.title}
              value={card.value}
              icon={card.icon}
              leadingIcon={card?.leadingIcon}
            />
          </div>
        ))}

        <div className="d-card-item" onClick={handleImportClick}>
          <DashboardCard
            title="Failed Imports"
            value={failedImportCount ?? 0}
            icon={ReceiptText}
            leadingIcon=""
          />
        </div>
      </div>
      <div className="map-section relative overflow-hidden rounded-2xl">
        <div className="absolute top-7 right-7 z-10">
          <SearchAndFilter placeholder="Search by store name or location" />
        </div>

        <div className="mb-6 w-full">
          <SubscriptionsBarChart />
        </div>

        <div className="map-holder relative pb-15">
          <MapSection />
        </div>
      </div>
    </div>
  );
};

export default DashboardMainComp;
